/* eslint-disable */
import React from 'react'
import DetailsPage from 'flow/SiteProposal/pages/Details'

const MonitoringDetailsPage = () => {
 

  return (
    <div>
     <DetailsPage/>
    </div>
  )
}

export default MonitoringDetailsPage
